export const TEST_ACTIVATION_ROUTE = '/test-activation';

export const ACTIVATION_TEST_FLOWS = ['candidate', 'company', 'recruiter'] as const;

export type ActivationTestFlow = (typeof ACTIVATION_TEST_FLOWS)[number];

export const isActivationTestFlow = (
  value: string | undefined
): value is ActivationTestFlow =>
  Boolean(value && (ACTIVATION_TEST_FLOWS as readonly string[]).includes(value));

export const activationTestFlowPath = (flow: ActivationTestFlow): string =>
  `${TEST_ACTIVATION_ROUTE}/${flow}`;
